import type {TravelerVisualState} from '../data/interfaces';

interface TravelerVisualColors {
  backgroundColor: string;
  textColor: string;
}

export const TRAVELER_OVERDUE_VISUAL_STATE = 'overdue';

const TRAVELER_VISUAL_COLORS: Record<TravelerVisualState, TravelerVisualColors> = {
  [TRAVELER_OVERDUE_VISUAL_STATE]: {
    backgroundColor: '#dc3545',
    textColor: 'white',
  },
  ready: {
    backgroundColor: '#198754',
    textColor: 'white',
  },
  coatings: {
    backgroundColor: '#f0ad4e',
    textColor: 'black',
  },
  production: {
    backgroundColor: '#6c757d',
    textColor: 'white',
  },
};

export function getTravelerVisualColors(
  visualState: TravelerVisualState
): TravelerVisualColors {
  return TRAVELER_VISUAL_COLORS[visualState];
}
